import { lazy } from 'react'

export const TermsOfUse = lazy(() => import('./TermsOfUse'))
